import Text from 'components/common/BaseText/BaseText'

import { ProjectProps } from './Project.types'

import './Project.scss'

const Project = ({ img, text, tags }: ProjectProps) => {
	return (
		<div className='project'>
			<div className='project__img-container'>
				<img className='project__img' src={img}></img>
			</div>
			<div className='project__description-container'>
				<Text>{text}</Text>
				<div className='project__tech-stack'>
					{tags.map(tag => (
						<span>{tag}</span>
					))}
				</div>
			</div>
		</div>
	)
}

export default Project
